"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var Spinner_vue_1 = __importDefault(require("@/components/spinner/Spinner.vue"));
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var TimeLine_vue_1 = __importDefault(require("@/components/time-line/TimeLine.vue"));
var MapRouteExtendedViewer_vue_1 = __importDefault(require("@/components/maps/map-route-extended-viewer/MapRouteExtendedViewer.vue"));
var SidePlannerForm_vue_1 = __importDefault(require("@/components/request-plan-form/side/SidePlannerForm.vue"));
var SimilarFeaturedPartnership_vue_1 = __importDefault(require("@/components/trip/featured-partnership-gallery/similar/SimilarFeaturedPartnership.vue"));
var rurallure_microservices_alerts_decoder_1 = require("rurallure-microservices-alerts-decoder");
var TripPilgrimCreation = /** @class */ (function (_super) {
    __extends(TripPilgrimCreation, _super);
    function TripPilgrimCreation() {
        var _this = _super.call(this) || this;
        _this.showMap = false;
        _this.mapLoading = true;
        _this.loader = true;
        _this.dateRange = {
            start: null,
            end: null
        };
        _this.description = '';
        _this.privacyLevelSelected = null;
        _this.transportSelected = null;
        _this.privacyLevels = [];
        _this.enableJoin = false;
        _this.hasSession = false;
        _this.validationError = false;
        _this.alternativePointsOfInterest = [];
        _this.invalidPlan = false;
        _this.warning = false;
        _this.warningMessages = [];
        return _this;
    }
    TripPilgrimCreation.prototype.mounted = function () {
        var _this = this;
        this.$getPartnershipDataService.request(this.$route.params.partnershipSlug).then(function (response) {
            _this.partnership = response;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
        this.plannerResponse = this.$browserStorage.setPersistLevelSession(true).get('planner_response');
        this.plannerRequest = this.$browserStorage.setPersistLevelSession(true).get('planner_request');
        if (this.plannerResponse === null) {
            this.$router.push({ name: 'partnershipHome' });
        }
        this.load_session();
        this.load_transport();
        this.load_alerts();
        this.loader = false;
    };
    TripPilgrimCreation.prototype.load_session = function () {
        var _this = this;
        this.hasSession = this.$oAuth2.getSessionId() !== null;
        this.$root.$on('AUTHENTICATED_EVENT', function () {
            _this.hasSession = true;
            if (_this.attemptedSave) {
                _this.$bvModal.show('save-trip-confirmation');
            }
        });
        this.$getPrivacyLevelsService.request().then(function (response) {
            _this.privacyLevels = response;
            _this.privacyLevels.forEach(function (privacyLevel) {
                if (privacyLevel.description === 'private') {
                    _this.privacyLevelSelected = privacyLevel;
                }
            });
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripPilgrimCreation.prototype.load_transport = function () {
        var _this = this;
        this.$getAllTransportsService.request().then(function (response) {
            response.forEach(function (transport) {
                var _a;
                if (((_a = _this.plannerResponse) === null || _a === void 0 ? void 0 : _a.plan.transport_id) === transport.id) {
                    _this.transportSelected = transport;
                }
            });
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripPilgrimCreation.prototype.load_alerts = function () {
        var _this = this;
        var _a, _b, _c, _d;
        if (((_b = (_a = this.plannerResponse) === null || _a === void 0 ? void 0 : _a.alerts) === null || _b === void 0 ? void 0 : _b.warnings) && ((_d = (_c = this.plannerResponse) === null || _c === void 0 ? void 0 : _c.alerts) === null || _d === void 0 ? void 0 : _d.warnings.length)) {
            this.warning = true;
            var alertDecoder_1 = new rurallure_microservices_alerts_decoder_1.AlertDecoder(this.$i18n.locale);
            this.plannerResponse.alerts.warnings.forEach(function (w_alert) {
                _this.warningMessages.push(alertDecoder_1.decode(w_alert.code));
            });
        }
    };
    TripPilgrimCreation.prototype.showMapFunction = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.invalidPlan) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, (this.$refs.timeLineComponent).hydrateRoutePois()];
                    case 1:
                        _a.sent();
                        this.showMap = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    TripPilgrimCreation.prototype.saveAttempt = function () {
        this.attemptedSave = true;
        this.$root.$emit('ASK_USER_CREDENTIALS');
    };
    TripPilgrimCreation.prototype.saveTrip = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        this.validationError = !this.validateData();
        if (this.validationError) {
            return;
        }
        this.$bvModal.hide('save-trip-confirmation');
        this.loader = true;
        var trip = {
            transport: this.transportSelected,
            start_gps_latitude: (_a = this.plannerResponse) === null || _a === void 0 ? void 0 : _a.plan.start_gps_latitude,
            start_gps_longitude: (_b = this.plannerResponse) === null || _b === void 0 ? void 0 : _b.plan.start_gps_longitude,
            end_gps_latitude: (_c = this.plannerResponse) === null || _c === void 0 ? void 0 : _c.plan.end_gps_latitude,
            end_gps_longitude: (_d = this.plannerResponse) === null || _d === void 0 ? void 0 : _d.plan.end_gps_longitude,
            date_from: (_e = this.plannerResponse) === null || _e === void 0 ? void 0 : _e.plan.date_from,
            date_to: (_f = this.plannerResponse) === null || _f === void 0 ? void 0 : _f.plan.date_to,
            preferences: [],
            route: (_g = this.plannerResponse) === null || _g === void 0 ? void 0 : _g.plan.route,
            description: this.description,
            enable_join: this.enableJoin,
            privacy: this.privacyLevelSelected,
            partnership: this.partnership
        };
        this.$createTripPilgrimService.request(trip).then(function () {
            _this.$browserStorage.setPersistLevelSession(true).remove('planner_response');
            _this.$router.push({ name: 'userPilgrimTrips' });
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    TripPilgrimCreation.prototype.validateData = function () {
        return this.description.length !== 0;
    };
    TripPilgrimCreation.prototype.onUpdatePlannerResponse = function () {
        var _this = this;
        this.loader = true;
        this.showMap = false;
        this.plannerResponse = this.$browserStorage.setPersistLevelSession(true).get('planner_response');
        this.plannerRequest = this.$browserStorage.setPersistLevelSession(true).get('planner_request');
        this.$nextTick(function () { return _this.loader = false; });
    };
    TripPilgrimCreation.prototype.changePrivacyLevel = function () {
        var _a;
        if (((_a = this.privacyLevelSelected) === null || _a === void 0 ? void 0 : _a.description) === 'private') {
            this.enableJoin = false;
        }
    };
    TripPilgrimCreation.prototype.setInvalidPlan = function (disabled) {
        this.invalidPlan = disabled;
    };
    TripPilgrimCreation = __decorate([
        vue_property_decorator_1.Component({
            name: 'TripPilgrimCreation',
            components: {
                Spinner: Spinner_vue_1.default,
                ViewWrapper: ViewWrapper_vue_1.default,
                TimeLine: TimeLine_vue_1.default,
                MapRouteExtendedViewer: MapRouteExtendedViewer_vue_1.default,
                SidePlannerForm: SidePlannerForm_vue_1.default,
                SimilarFeaturedPartnership: SimilarFeaturedPartnership_vue_1.default
            }
        })
    ], TripPilgrimCreation);
    return TripPilgrimCreation;
}(vue_1.default));
exports.default = TripPilgrimCreation;
